// frontend/modules/customer-loan-info/views/CustomerLoanInfoView.tsx
import React from 'react';
import { Typography, Space } from 'antd';
import { CustomerLoanSearchForm } from '../components/CustomerLoanSearchForm';
import { LoanInfoDisplay } from '../components/LoanInfoDisplay';
import { useCustomerLoanInfo } from '../hooks/useCustomerLoanInfo';

const { Title } = Typography;

export const CustomerLoanInfoView: React.FC = () => {
  const {
    searchParams,
    isLoading,
    error,
    customerLoanInfo,
    searchCustomerLoan,
    clearSearch,
  } = useCustomerLoanInfo();

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Customer Loan Information</Title>
      
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <CustomerLoanSearchForm
          onSearch={searchCustomerLoan}
          onClear={clearSearch}
          loading={isLoading}
        />
        
        {searchParams && (
          <LoanInfoDisplay
            loanInfo={customerLoanInfo}
            loading={isLoading}
            error={error}
          />
        )}
      </Space>
    </div>
  );
};
